module.exports = __webpack_public_path__ + "img/Sports-low.16a32f9f.jpg";